import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { map, Subscription } from 'rxjs';
import { LoaderService } from './core_modules/common/services/loader.service';
import { ReleaseService } from './core_modules/common/services/release.service';
import { ScriptLoaderService } from './core_modules/common/services/script-loader.service';
import { LocalStorageUtil } from './core_modules/utils/local-storage-util';
import { environment } from '../environments/environment';

import { SpinnerComponent } from './core_modules/common/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'creditx-frontend';

  showLoader: boolean = false;
  private loaderSubscription!: Subscription;

  preLoadingFiles = [
    'assets/custom-js/simplebar.min.js',
    'assets/custom-js/app.js',
  ];

  constructor(
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private renderer: Renderer2,
    private titleService: Title,
    private scriptLoaderService: ScriptLoaderService,
    private activatedRoute: ActivatedRoute,
    private releaseService: ReleaseService,
  ) {}

  ngOnInit() {
    this.loadTheme();
    console.log('Registered Routes:', this.router.config);
    console.log(
      '[localStorage]',
      environment.appConfigName,
      '=>',
      LocalStorageUtil.getStorage(),
    );

    this.releaseService.checkForNewRelease();
    const appTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        map((events) => {
          if (events instanceof NavigationEnd) {
            this.resetExistingDetailsWhileNavigating();
            let storageDetails: LocalStorageUtil | any =
              LocalStorageUtil.getStorage();

            // remove loanModuleDetails if navigate to other route rather than loan-modules
            if (
              !this.router.url.includes('/loan-modules') &&
              !this.router.url.includes('/customer/security') &&
              !this.router.url.includes('/customer/insurance') &&
              !this.router.url.includes('/common-features')
            ) {
              delete storageDetails['loanModuleDetails'];
              LocalStorageUtil.setStorage(storageDetails);
            }

            if (
              this.router.url.includes(
                '/customer-modules/customer/customer-info/customer-profile-view',
              )
            ) {
              delete storageDetails['taggedSecurity'];
              delete storageDetails['loanDetails'];
              LocalStorageUtil.setStorage(storageDetails);
            }

            setTimeout(() => {
              this.preLoadingFiles?.forEach((value) => {
                const scriptElement = this.scriptLoaderService.loadJsScript(
                  this.renderer,
                  value,
                );
                scriptElement.onload = () => {
                  scriptElement.remove();
                };
                scriptElement.onerror = () => {
                  console.log('Could not load the External Script!');
                };
              });
            }, 500);
          }

          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          if (child?.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        }),
      )
      .subscribe((t: string) => {
        this.titleService.setTitle(t + environment.productSlogan);
      });
  }

  loadTheme(): void {
    const primaryColor = localStorage.getItem('primaryColor');

    if (primaryColor) {
      document.documentElement.style.setProperty(
        '--mbank-primary',
        primaryColor,
      );
      document.documentElement.style.setProperty(
        '--color-primary',
        primaryColor,
      );
    }
  }

  private resetExistingDetailsWhileNavigating() {}

  ngAfterViewInit() {
    this.loaderSubscription = this.loaderService?.isLoading$?.subscribe(
      (val: boolean) => {
        setTimeout(() => {
          this.showLoader = val;
        });
      },
    );
  }

  ngOnDestroy() {
    this.loaderSubscription.unsubscribe();
  }
}
